import { Component, inject } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { compare } from "fast-json-patch";
import { NEVER } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { FormControlBase } from "src/app/common-components/form-controls/form-control-base";
import { CstResponsivePopupComponentBase } from "src/app/common-components/resp-popup";
import {
  InfoportalFoldersClientProvider,
  ReceiptFolderLookupDto,
  ValidationResult,
} from "src/app/web-api/web-api";
import {
  CstFormBuilder,
  CstFormGroup,
} from "src/app/_uncategorised_models_services/cst-form-group";

interface IReceiptFolderUpdateCommand {
  label: string;
  description: string;
  tagIDs: number[];
}

export interface IInfoportalApiReceiptFolderUpdateDialogData {
  id: string;
}

@Component({
  templateUrl: "./receipt-folder-update-dialog.component.html",
  styleUrls: ["./receipt-folder-update-dialog.component.scss"],
  standalone: false,
  host: { "data-dialog-unique": "receipt-folder-update-dialog" }, // fixes https://v21.angular.dev/errors/NG0912
})
export class InfoportalApiReceiptFolderUpdateDialogComponent extends CstResponsivePopupComponentBase<
  IInfoportalApiReceiptFolderUpdateDialogData,
  ReceiptFolderLookupDto
> {
  private _client = inject(InfoportalFoldersClientProvider);

  private _origonalValue: IReceiptFolderUpdateCommand;

  public form: CstFormGroup<IReceiptFolderUpdateCommand>;
  public loading = false;

  constructor() {
    const fb = inject(CstFormBuilder);

    super();

    this.form = fb.group<IReceiptFolderUpdateCommand>({
      label: new FormControl(null, [
        Validators.required,
        Validators.maxLength(75),
      ]),
      description: new FormControl(null, Validators.maxLength(2000)),
      tagIDs: new FormControl([]),
    });
  }

  onInitialised() {
    this._client.receiptFolderGet(this.data.id).subscribe((result) => {
      this.form.patchValue({ ...result, tagIDs: result.tags.map((x) => x.id) });
      this._origonalValue = { ...this.form.value };
    });
  }

  public canAccept() {
    return this.data.id && this.form.valid;
  }
  public onAccept() {
    if (!this.canAccept()) {
      return;
    }
    this.loading = true;
    const patch = compare(this._origonalValue, this.form.value);
    if (patch.length === 0) {
      this.close();
    }
    this._client
      .receiptFolderPatch(this.data.id, patch as any)
      .pipe(
        finalize(() => (this.loading = false)),
        catchError((error) => {
          if (error instanceof ValidationResult) {
            FormControlBase.ApplyValidationResultToForm(this.form, error);
            return NEVER;
          }
          console.error(error);
          return NEVER;
        }),
      )
      .subscribe((result) => this.close(result));
  }

  public onCancel() {
    this.close();
  }
}
